// ═══════════════════════════════════════════════════════════
//  CONFIGURAÇÃO — altere apenas este bloco por página
// ═══════════════════════════════════════════════════════════

const WHATSAPP = '551151922822';
const CDN = 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/';

const TROFEUS = [
  {
    id: 'trofeu1',
    nome: 'Troféu Infinity',
    precos: { '15cm': 'R$ 45', '20cm': 'R$ 50' },
    swatch: CDN + 'trofeu1.swatch.webp',
    logotemplate: CDN + 'trofeu1.logotemplate.webp',
    partes: [
      {
        id: 'base',
        label: 'Base',
        corPadrao: '#1a1a1a',
        pngs: {
          silhueta: CDN + 'trofeu1.corbase.webp',
          sombras:  CDN + 'trofeu1.basebranca.webp',
          luzes:    CDN + 'trofeu1.basepreta.webp',
        },
      },
      {
        id: 'corpo',
        label: 'Corpo',
        corPadrao: '#eca710',
        pngs: {
          silhueta: CDN + 'trofeu1.corcorpo.webp',
          sombras:  CDN + 'trofeu1.superexposicao.webp',
          luzes:    CDN + 'trofeu1.screen.webp',
        },
      },
    ],
    placas: [
      { id: 'placalogo', label: 'Placa (logo)',  corPadrao: '#ffffff', silhueta: CDN + 'trofeu1.corplacalogo.webp' },
      { id: 'placa',     label: 'Placa (texto)', corPadrao: '#ffffff', silhueta: CDN + 'trofeu1.corplaca.webp' },
    ],
  },
  {
    id: 'trofeu2',
    nome: 'Troféu Ascend',
    precos: { '15cm': 'R$ 45', '20cm': 'R$ 50' },
    swatch: CDN + 'trofeu2.swatch.webp',
    logotemplate: CDN + 'trofeu2.logotemplate.webp',
    partes: [
      {
        id: 'base',
        label: 'Base',
        corPadrao: '#1a1a1a',
        pngs: {
          silhueta: CDN + 'trofeu2.corbase.webp',
          sombras:  CDN + 'trofeu2.basebranca.webp',
          luzes:    CDN + 'trofeu2.basepreta.webp',
        },
      },
      {
        id: 'corpo',
        label: 'Corpo',
        corPadrao: '#eca710',
        pngs: {
          silhueta: CDN + 'trofeu2.corcorpo.webp',
          sombras:  CDN + 'trofeu2.superexposicao.webp',
          luzes:    CDN + 'trofeu2.screen.webp',
        },
      },
    ],
    placas: [
      { id: 'placalogo', label: 'Placa (logo + texto)', corPadrao: '#ffffff', silhueta: CDN + 'trofeu2.corplacalogoetexto.webp' },
    ],
  },
  {
    id: 'trofeu3',
    nome: 'Troféu Aegis',
    precos: { '15cm': 'R$ 75', '20cm': 'R$ 80' },
    swatch: CDN + 'trofeu3.swatch.webp',
    logotemplate: CDN + 'trofeu3.logotemplate.webp',
    partes: [
      {
        id: 'base',
        label: 'Base',
        corPadrao: '#1a1a1a',
        pngs: {
          silhueta: CDN + 'trofeu3.corbase.webp',
          sombras:  CDN + 'trofeu3.basebranca.webp',
          luzes:    CDN + 'trofeu3.basepreta.webp',
        },
      },
      {
        id: 'corpo1',
        label: 'Corpo 1',
        corPadrao: '#505050',
        pngs: {
          silhueta: CDN + 'trofeu3.corcorpo.webp',
          sombras:  CDN + 'trofeu3.superexposicao.webp',
          luzes:    CDN + 'trofeu3.screen.webp',
        },
      },
      {
        id: 'corpo2',
        label: 'Corpo 2',
        corPadrao: '#eca710',
        pngs: { silhueta: CDN + 'trofeu3.corcorpo2.webp' },
      },
    ],
    placas: [
      { id: 'placalogo', label: 'Placa (logo)',  corPadrao: '#ffffff', silhueta: CDN + 'trofeu3.corplacalogo.webp' },
      { id: 'placa',     label: 'Placa (texto)', corPadrao: '#ffffff', silhueta: CDN + 'trofeu3.corplaca.webp' },
    ],
  },
  {
    id: 'trofeu4',
    nome: 'Troféu Alliance',
    precos: { '15cm': 'R$ 75', '20cm': 'R$ 80' },
    swatch: CDN + 'trofeu4.swatch.webp',
    logotemplate: CDN + 'trofeu4.logotemplate.webp',
    partes: [
      {
        id: 'base',
        label: 'Base',
        corPadrao: '#1a1a1a',
        pngs: {
          silhueta: CDN + 'trofeu4.corbase.webp',
          sombras:  CDN + 'trofeu4.basebranca.webp',
          luzes:    CDN + 'trofeu4.basepreta.webp',
        },
      },
      {
        id: 'corpo1',
        label: 'Corpo 1',
        corPadrao: '#eca710',
        pngs: {
          silhueta: CDN + 'trofeu4.corcorpo.webp',
          sombras:  CDN + 'trofeu4.superexposicao.webp',
          luzes:    CDN + 'trofeu4.screen.webp',
        },
      },
      {
        id: 'corpo2',
        label: 'Corpo 2',
        corPadrao: '#eca710',
        pngs: { silhueta: CDN + 'trofeu4.corcorpo2.webp' },
      },
    ],
    placas: [
      { id: 'placa', label: 'Placa (texto)', corPadrao: '#ffffff', silhueta: CDN + 'trofeu4.corplaca.webp' },
    ],
  },
  {
    id: 'trofeu5',
    nome: 'Troféu Emblem',
    precos: { '15cm': 'R$ 65', '20cm': 'R$ 70' },
    swatch: CDN + 'trofeu5.swatch.webp',
    logotemplate: CDN + 'trofeu5.logotemplate.webp',
    partes: [
      {
        id: 'base',
        label: 'Base',
        corPadrao: '#1a1a1a',
        pngs: {
          silhueta: CDN + 'trofeu5.corbase.webp',
          sombras:  CDN + 'trofeu5.basebranca.webp',
          luzes:    CDN + 'trofeu5.basepreta.webp',
        },
      },
      {
        id: 'corpo1',
        label: 'Corpo 1',
        corPadrao: '#eca710',
        pngs: {
          silhueta: CDN + 'trofeu5.corcorpo.webp',
          sombras:  CDN + 'trofeu5.superexposicao.webp',
          luzes:    CDN + 'trofeu5.screen.webp',
        },
      },
    ],
    placas: [
      { id: 'placa', label: 'Placa (texto)', corPadrao: '#ffffff', silhueta: CDN + 'trofeu5.corplaca.webp' },
    ],
  },
  {
    id: 'trofeu6',
    nome: 'Troféu Crownspire',
    precos: { '15cm': 'R$ 55', '20cm': 'R$ 60' },
    swatch: CDN + 'trofeu6.swatch.webp',
    logotemplate: CDN + 'trofeu6.logotemplate.webp',
    partes: [
      {
        id: 'base',
        label: 'Base',
        corPadrao: '#1a1a1a',
        pngs: {
          silhueta: CDN + 'trofeu6.corbase.webp',
          sombras:  CDN + 'trofeu6.basebranca.webp',
          luzes:    CDN + 'trofeu6.basepreta.webp',
        },
      },
      {
        id: 'corpo1',
        label: 'Corpo 1',
        corPadrao: '#eca710',
        pngs: {
          silhueta: CDN + 'trofeu6.corcorpo.webp',
          sombras:  CDN + 'trofeu6.superexposicao.webp',
          luzes:    CDN + 'trofeu6.screen.webp',
        },
      },
      {
        id: 'corpo2',
        label: 'Corpo 2',
        corPadrao: '#eca710',
        pngs: { silhueta: CDN + 'trofeu6.corcorpo2.webp' },
      },
    ],
    placas: [
      { id: 'placa', label: 'Placa (texto)', corPadrao: '#ffffff', silhueta: CDN + 'trofeu6.corplaca.webp' },
    ],
  },
];

// ═══════════════════════════════════════════════════════════
//  PALETA DE CORES
// ═══════════════════════════════════════════════════════════

function gerarPaleta() {
  const hues  = [0, 25, 48, 72, 100, 135, 160, 190, 210, 240, 265, 290, 315, 340];
  const linhas = [
    { s: 40,  l: 90 }, { s: 60,  l: 80 }, { s: 80,  l: 70 },
    { s: 95,  l: 60 }, { s: 100, l: 50 }, { s: 100, l: 40 },
    { s: 95,  l: 30 }, { s: 85,  l: 20 }, { s: 70,  l: 12 },
  ];
  const cores = [];
  linhas.forEach(({ s, l }) => hues.forEach(h => {
    const hex = hslToHex(h, s, l);
    cores.push({ visual: hex, trofeu: hex, nome: nomeHSL(h, s, l) });
  }));
  const neutros = [
    { visual: '#ffffff', trofeu: '#ffffff', nome: 'Branco' },
    { visual: '#e8e8e8', trofeu: '#e8e8e8', nome: 'Cinza claro' },
    { visual: '#c8c8c8', trofeu: '#c8c8c8', nome: 'Cinza' },
    { visual: '#a0a0a0', trofeu: '#a0a0a0', nome: 'Cinza médio' },
    { visual: '#787878', trofeu: '#787878', nome: 'Cinza escuro' },
    { visual: '#505050', trofeu: '#505050', nome: 'Chumbo' },
    { visual: '#303030', trofeu: '#303030', nome: 'Quase preto' },
    { visual: '#181818', trofeu: '#181818', nome: 'Preto' },
    { visual: '#dab231', trofeu: '#eca710', nome: 'Ouro' },
    { visual: '#b0b8c8', trofeu: '#b0b8c8', nome: 'Prata' },
    { visual: '#994e30', trofeu: '#994e30', nome: 'Bronze' },
    { visual: '#976f19', trofeu: '#7e5808', nome: 'Ouro Escuro' },
    { visual: '#1a2a6e', trofeu: '#1a2a6e', nome: 'Azul marinho' },
    { visual: '#8b0000', trofeu: '#8b0000', nome: 'Vinho' },
  ];
  return { cores, neutros, colunas: hues.length };
}

function hslToHex(h, s, l) {
  s /= 100; l /= 100;
  const a = s * Math.min(l, 1 - l);
  const f = n => {
    const k = (n + h / 30) % 12;
    const c = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * c).toString(16).padStart(2, '0');
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

function nomeHSL(h, s, l) {
  const matizes = ['Vermelho','Laranja','Amarelo','Verde-amarelo','Verde','Verde-azulado','Ciano','Azul-claro','Azul','Azul-roxo','Roxo','Violeta','Rosa-roxo','Rosa'];
  const idx = Math.round(h / (360 / 14)) % 14;
  if (l > 75) return matizes[idx] + ' claro';
  if (l < 25) return matizes[idx] + ' escuro';
  return matizes[idx];
}

// ═══════════════════════════════════════════════════════════
//  ESTADO
// ═══════════════════════════════════════════════════════════

let TROPHY = TROFEUS[0];
let tamanhoSelecionado = '15cm';

const estado = { cores: {}, toggles: {} };
let displayCores = {}; // cores interpoladas para animação suave

function iniciarEstado() {
  estado.cores   = {};
  estado.toggles = {};
  TROPHY.partes.forEach(p => { estado.cores[p.id] = p.corPadrao; });
  TROPHY.placas.forEach(p => { estado.cores[p.id] = p.corPadrao; });
  displayCores = { ...estado.cores };
}

// Converte hex → [r,g,b]
function hexToRgb(hex) {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

// Interpola dois hex com t ∈ [0,1]
function lerpHex(a, b, t) {
  const [ar,ag,ab] = hexToRgb(a);
  const [br,bg,bb] = hexToRgb(b);
  const r = Math.round(ar + (br - ar) * t);
  const g = Math.round(ag + (bg - ag) * t);
  const bl = Math.round(ab + (bb - ab) * t);
  return `#${r.toString(16).padStart(2,'0')}${g.toString(16).padStart(2,'0')}${bl.toString(16).padStart(2,'0')}`;
}

let animating = false;

function startAnimation() {
  if (animating) return;
  animating = true;
  const SPEED = 0.12; // 0–1 por frame (~60fps → ~350ms)

  function tick() {
    let allDone = true;
    for (const id of Object.keys(estado.cores)) {
      const target  = estado.cores[id];
      const current = displayCores[id] || target;
      if (current === target) continue;
      allDone = false;
      displayCores[id] = lerpHex(current, target, SPEED);
      // Se muito próximo, snap direto
      if (hexToRgb(displayCores[id]).every((v,i) => Math.abs(v - hexToRgb(target)[i]) < 2)) {
        displayCores[id] = target;
      }
    }
    renderCanvas();
    if (!allDone) requestAnimationFrame(tick);
    else animating = false;
  }
  requestAnimationFrame(tick);
}

// ═══════════════════════════════════════════════════════════
//  CACHE DE IMAGENS
// ═══════════════════════════════════════════════════════════

const imgCache = new Map();

function loadImg(src) {
  if (imgCache.has(src)) return imgCache.get(src);
  const p = new Promise(res => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload  = () => res(img);
    img.onerror = () => res(null);
    img.src = src;
  });
  imgCache.set(src, p);
  return p;
}

function preloadTrophy(trofeu) {
  const urls = [];
  trofeu.partes.forEach(p => {
    if (!p.pngs) return;
    if (p.pngs.silhueta) urls.push(p.pngs.silhueta);
    if (p.pngs.sombras)  urls.push(p.pngs.sombras);
    if (p.pngs.luzes)    urls.push(p.pngs.luzes);
  });
  trofeu.placas.forEach(p => { if (p.silhueta) urls.push(p.silhueta); });
  if (trofeu.logotemplate) urls.push(trofeu.logotemplate);
  urls.forEach(loadImg);
}

// ═══════════════════════════════════════════════════════════
//  INIT
// ═══════════════════════════════════════════════════════════

document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('trophy-nome').textContent = TROPHY.nome;
  iniciarEstado();
  TROFEUS.forEach(preloadTrophy);
  buildModelosSeletor();
  buildTamanhoSeletor();
  atualizarPreco();
  buildMockupCanvas();
  buildPartesPanel();
  buildColorPickerGrid();
  bindSalvar();
  bindWhatsApp();
  renderCanvas();
});

// ═══════════════════════════════════════════════════════════
//  SELETOR DE MODELO
// ═══════════════════════════════════════════════════════════

function buildModelosSeletor() {
  const lista = document.getElementById('modelos-list');
  lista.innerHTML = '';
  TROFEUS.forEach((trofeu, i) => {
    const btn = document.createElement('button');
    btn.className = 'modelo-swatch' + (i === 0 ? ' active' : '');
    btn.title = trofeu.nome;
    btn.dataset.id = trofeu.id;
    const img = document.createElement('img');
    img.src = trofeu.swatch;
    img.alt = trofeu.nome;
    const nome = document.createElement('span');
    nome.className = 'modelo-swatch-nome';
    nome.textContent = trofeu.nome;
    btn.appendChild(img);
    btn.appendChild(nome);
    btn.addEventListener('click', () => selecionarModelo(trofeu.id));
    lista.appendChild(btn);
  });
}

function selecionarModelo(id) {
  const trofeu = TROFEUS.find(t => t.id === id);
  if (!trofeu || trofeu === TROPHY) return;
  TROPHY = trofeu;
  iniciarEstado();
  document.querySelectorAll('.modelo-swatch').forEach(b => b.classList.toggle('active', b.dataset.id === id));
  document.getElementById('trophy-nome').textContent = TROPHY.nome;
  atualizarPreco();
  buildPartesPanel();
  fecharPopover();
  renderCanvas();
}

function buildTamanhoSeletor() {
  const lista = document.getElementById('tamanho-list');
  if (!lista) return;
  lista.innerHTML = '';
  ['15cm', '20cm'].forEach(tam => {
    const btn = document.createElement('button');
    btn.className = 'tamanho-btn' + (tam === tamanhoSelecionado ? ' active' : '');
    btn.textContent = tam;
    btn.addEventListener('click', () => {
      tamanhoSelecionado = tam;
      document.querySelectorAll('.tamanho-btn').forEach(b => b.classList.toggle('active', b.textContent === tam));
      atualizarPreco();
    });
    lista.appendChild(btn);
  });
}

function atualizarPreco() {
  const el = document.getElementById('trophy-preco');
  if (!el) return;
  const val = TROPHY.precos && TROPHY.precos[tamanhoSelecionado];
  el.innerHTML = val
    ? `${val}<span class="sct-price-cada">cada</span><span class="sct-price-note"> · orçamento via WhatsApp</span>`
    : `Valor sob consulta <span class="sct-price-note">— orçamento via WhatsApp</span>`;
}

// ═══════════════════════════════════════════════════════════
//  MOCKUP — canvas único no lugar dos CSS layers
// ═══════════════════════════════════════════════════════════

function buildMockupCanvas() {
  const wrap = document.getElementById('mockup-wrap');
  wrap.innerHTML = '';
  const canvas = document.createElement('canvas');
  canvas.id = 'mockup-canvas';
  canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;';
  wrap.appendChild(canvas);
}

let renderPending = false;

async function renderCanvas() {
  if (renderPending) return;
  renderPending = true;
  await new Promise(r => requestAnimationFrame(r));
  renderPending = false;

  const wrap   = document.getElementById('mockup-wrap');
  const canvas = document.getElementById('mockup-canvas');
  if (!canvas) return;

  // Descobre dimensões reais pelo primeiro silhueta disponível
  const primeiroSrc = TROPHY.partes.find(p => p.pngs?.silhueta)?.pngs.silhueta;
  const primeiroImg = primeiroSrc ? await loadImg(primeiroSrc) : null;
  const W = primeiroImg ? primeiroImg.naturalWidth  : wrap.offsetWidth  * 2;
  const H = primeiroImg ? primeiroImg.naturalHeight : wrap.offsetHeight * 2;

  canvas.width  = W;
  canvas.height = H;
  const ctx = canvas.getContext('2d');

  const drawMasked = async (color, silhuetaSrc) => {
    const silhueta = await loadImg(silhuetaSrc);
    if (!silhueta) return;
    const tmp = document.createElement('canvas');
    tmp.width = W; tmp.height = H;
    const t = tmp.getContext('2d');
    t.fillStyle = color;
    t.fillRect(0, 0, W, H);
    t.globalCompositeOperation = 'destination-in';
    t.drawImage(silhueta, 0, 0, W, H);
    ctx.globalCompositeOperation = 'source-over';
    ctx.drawImage(tmp, 0, 0);
  };

  ctx.fillStyle = '#f3f3f3';
  ctx.fillRect(0, 0, W, H);

  // 1. Cores mascaradas pelas silhuetas (usa displayCores para animação suave)
  for (const parte of TROPHY.partes) {
    if (!parte.pngs?.silhueta) continue;
    await drawMasked(displayCores[parte.id] || parte.corPadrao, parte.pngs.silhueta);
  }
  for (const placa of TROPHY.placas) {
    if (!placa.silhueta) continue;
    await drawMasked(displayCores[placa.id] || placa.corPadrao, placa.silhueta);
  }

  // 2. Logo template
  if (TROPHY.logotemplate) {
    const lt = await loadImg(TROPHY.logotemplate);
    if (lt) { ctx.globalCompositeOperation = 'source-over'; ctx.drawImage(lt, 0, 0, W, H); }
  }

  // 3. Sombras (multiply) + Luzes (screen)
  for (const parte of TROPHY.partes) {
    if (!parte.pngs) continue;
    if (parte.pngs.sombras) {
      const img = await loadImg(parte.pngs.sombras);
      if (img) { ctx.globalCompositeOperation = 'multiply'; ctx.drawImage(img, 0, 0, W, H); }
    }
    if (parte.pngs.luzes) {
      const img = await loadImg(parte.pngs.luzes);
      if (img) { ctx.globalCompositeOperation = 'screen'; ctx.drawImage(img, 0, 0, W, H); }
    }
  }
  ctx.globalCompositeOperation = 'source-over';
}

// ═══════════════════════════════════════════════════════════
//  PAINEL
// ═══════════════════════════════════════════════════════════

let parteAtiva = null;

function buildPartesPanel() {
  const listaCorpo = document.getElementById('partes-list');
  listaCorpo.innerHTML = '';
  TROPHY.partes.forEach(parte => listaCorpo.appendChild(criarItemParte(parte)));

  const listaPlacas = document.getElementById('placas-list');
  listaPlacas.innerHTML = '';
  TROPHY.placas.forEach(placa => {
    const item = document.createElement('div');
    item.className = 'parte-item';
    const label = document.createElement('span');
    label.className = 'parte-label';
    label.textContent = placa.label;
    const btns = document.createElement('div');
    btns.className = 'parte-btns';
    btns.style.position = 'relative';
    const btn = document.createElement('button');
    btn.className = 'parte-btn-cor';
    btn.id = `btn-cor-${placa.id}`;
    btn.style.backgroundColor = placa.corPadrao;
    btn.title = 'Escolher cor';
    btn.addEventListener('click', e => { e.stopPropagation(); abrirPopover(placa.id, btn); });
    const nomeEl = document.createElement('span');
    nomeEl.className = 'parte-cor-nome';
    nomeEl.id = `nome-cor-${placa.id}`;
    nomeEl.textContent = '—';
    btns.appendChild(btn);
    btns.appendChild(nomeEl);
    item.appendChild(label);
    item.appendChild(btns);
    listaPlacas.appendChild(item);
  });
}

function criarItemParte(parte) {
  const item = document.createElement('div');
  item.className = 'parte-item';
  const label = document.createElement('span');
  label.className = 'parte-label';
  label.textContent = parte.label;
  const btns = document.createElement('div');
  btns.className = 'parte-btns';
  btns.style.position = 'relative';
  const btn = document.createElement('button');
  btn.className = 'parte-btn-cor';
  btn.id = `btn-cor-${parte.id}`;
  btn.style.backgroundColor = parte.corPadrao;
  btn.title = 'Escolher cor';
  btn.addEventListener('click', e => { e.stopPropagation(); abrirPopover(parte.id, btn); });
  const nomeEl = document.createElement('span');
  nomeEl.className = 'parte-cor-nome';
  nomeEl.id = `nome-cor-${parte.id}`;
  nomeEl.textContent = '—';
  btns.appendChild(btn);
  btns.appendChild(nomeEl);
  item.appendChild(label);
  item.appendChild(btns);
  return item;
}

// ═══════════════════════════════════════════════════════════
//  COLOR PICKER
// ═══════════════════════════════════════════════════════════

const paleta = gerarPaleta();

function buildColorPickerGrid() {
  const grid = document.getElementById('picker-grid-global');
  grid.style.gridTemplateColumns = `repeat(${paleta.colunas}, 22px)`;
  grid.innerHTML = '';
  paleta.cores.forEach(cor => grid.appendChild(criarCell(cor)));
  const sep = document.createElement('div');
  sep.style.cssText = `grid-column:1/-1;height:1px;background:rgba(18,18,18,0.08);margin:4px 0;`;
  grid.appendChild(sep);
  const neutrosWrap = document.createElement('div');
  neutrosWrap.style.cssText = `grid-column:1/-1;display:flex;flex-wrap:wrap;gap:4px;`;
  paleta.neutros.forEach(cor => neutrosWrap.appendChild(criarCell(cor)));
  grid.appendChild(neutrosWrap);
}

function criarCell(cor) {
  const btn = document.createElement('button');
  btn.className = 'picker-cell';
  btn.style.backgroundColor = cor.visual;
  btn.dataset.visual = cor.visual;
  btn.dataset.trofeu = cor.trofeu;
  btn.dataset.nome   = cor.nome;
  btn.title = cor.nome;
  btn.addEventListener('mouseenter', () => { document.getElementById('picker-nome-hover').textContent = cor.nome; });
  btn.addEventListener('mouseleave', () => { document.getElementById('picker-nome-hover').textContent = ''; });
  btn.addEventListener('click', () => selecionarCor(cor));
  return btn;
}

// ═══════════════════════════════════════════════════════════
//  POPOVER
// ═══════════════════════════════════════════════════════════

function abrirPopover(parteId, btnRef) {
  const popover = document.getElementById('popover-global');
  if (parteAtiva === parteId && popover.classList.contains('open')) { fecharPopover(); return; }
  parteAtiva = parteId;
  atualizarCelulaSelecionada(estado.cores[parteId]);

  if (window.innerWidth > 600) {
    const rect = btnRef.getBoundingClientRect();
    popover.style.top  = `${rect.bottom + 8}px`;
    popover.style.left = `${Math.min(rect.left, window.innerWidth - 340)}px`;
  }

  popover.classList.add('open');
  document.getElementById('picker-overlay')?.classList.add('open');
  document.querySelectorAll('.parte-btn-cor').forEach(b => b.classList.remove('active'));
  btnRef.classList.add('active');
}

function fecharPopover() {
  document.getElementById('popover-global').classList.remove('open');
  document.getElementById('picker-overlay')?.classList.remove('open');
  document.querySelectorAll('.parte-btn-cor').forEach(b => b.classList.remove('active'));
  parteAtiva = null;
}

document.addEventListener('click', fecharPopover);
document.getElementById('picker-overlay')?.addEventListener('click', fecharPopover);
document.getElementById('popover-global').addEventListener('click', e => e.stopPropagation());

// ═══════════════════════════════════════════════════════════
//  SELECIONAR COR
// ═══════════════════════════════════════════════════════════

function selecionarCor(cor) {
  if (!parteAtiva) return;
  estado.cores[parteAtiva] = cor.trofeu;
  const btn = document.getElementById(`btn-cor-${parteAtiva}`);
  if (btn) btn.style.backgroundColor = cor.visual;
  const nomeEl = document.getElementById(`nome-cor-${parteAtiva}`);
  if (nomeEl) nomeEl.textContent = cor.nome;
  atualizarCelulaSelecionada(cor.trofeu);
  startAnimation();
}

function atualizarCelulaSelecionada(hexAtual) {
  document.querySelectorAll('.picker-cell').forEach(c => {
    c.classList.toggle('selected', c.dataset.trofeu === hexAtual);
  });
}

// ═══════════════════════════════════════════════════════════
//  SALVAR
// ═══════════════════════════════════════════════════════════

function bindSalvar() {
  document.getElementById('btn-salvar').addEventListener('click', async () => {
    const btn = document.getElementById('btn-salvar');
    btn.textContent = 'Salvando...';
    btn.disabled = true;
    try {
      // Reutiliza o canvas já renderizado
      const canvas = document.getElementById('mockup-canvas');
      const link = document.createElement('a');
      link.download = `${TROPHY.nome.replace(/\s+/g, '-')}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    } finally {
      btn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg> Salvar modelo`;
      btn.disabled = false;
    }
  });
}

// ═══════════════════════════════════════════════════════════
//  WHATSAPP
// ═══════════════════════════════════════════════════════════

function bindWhatsApp() {
  document.getElementById('btn-whatsapp').addEventListener('click', () => {
    const linhas = [`*Pedido de Troféu — ${TROPHY.nome}*`];
    TROPHY.partes.forEach(p => {
      const nome = document.getElementById(`nome-cor-${p.id}`)?.textContent || estado.cores[p.id];
      linhas.push(`• ${p.label}: ${nome} (${estado.cores[p.id]})`);
    });
    TROPHY.placas.forEach(p => {
      const nome = document.getElementById(`nome-cor-${p.id}`)?.textContent || estado.cores[p.id];
      linhas.push(`• ${p.label}: ${nome} (${estado.cores[p.id]})`);
    });
    linhas.push('');
    linhas.push('*Para finalizar, envie nesta conversa:*');
    linhas.push('1. Imagem do seu logotipo (PNG ou JPG)');
    linhas.push('2. Texto principal da placa (ex: nome do time, campeão, ano)');
    linhas.push('3. Texto secundário, se houver (ex: categoria, data)');
    const msg = encodeURIComponent(linhas.join('\n'));
    window.open(`https://wa.me/${WHATSAPP}?text=${msg}`, '_blank');
  });
}
